import { render, staticRenderFns } from "./AdditionalNotes.vue?vue&type=template&id=067ed42d&scoped=true"
import script from "./AdditionalNotes.vue?vue&type=script&lang=ts"
export * from "./AdditionalNotes.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalNotes.vue?vue&type=style&index=0&id=067ed42d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ed42d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067ed42d')) {
      api.createRecord('067ed42d', component.options)
    } else {
      api.reload('067ed42d', component.options)
    }
    module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=067ed42d&scoped=true", function () {
      api.rerender('067ed42d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/AdditionalNotes.vue"
export default component.exports